@if (patientForm) {
  <div class="page-column">
    <div class="title">
      <div class="typo-h2">{{ "profile.patient.title" | transloco }}</div>
    </div>

    <form [formGroup]="patientForm" class="column">
      <mat-form-field class="flex" hideRequiredMarker subscriptSizing="dynamic">
        <mat-label>{{ "form.label.firstName" | transloco }}</mat-label>
        <input formControlName="firstName" matInput>
      </mat-form-field>

      <mat-form-field class="flex" hideRequiredMarker subscriptSizing="dynamic">
        <mat-label>{{ "form.label.lastName" | transloco }}</mat-label>
        <input formControlName="lastName" matInput>
      </mat-form-field>

      <div class="row">
        <mat-form-field class="flex min-width" floatLabel="always" hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ "form.label.dateOfBirth" | transloco }}</mat-label>
          <input [placeholder]="'form.placeholder.date' | transloco" appDateMask formControlName="dateOfBirth" matInput>
          <mat-icon matSuffix>calendar_month</mat-icon>
          <mat-error>{{ 'form.validation.dateOfBirth' | transloco }}</mat-error>
        </mat-form-field>

        <mat-form-field class="flex min-width" floatLabel="always" hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ "form.label.sex" | transloco }}</mat-label>
          <mat-select [placeholder]="'form.placeholder.select' | transloco" formControlName="sex">
            @for (sex of sexes; track $index) {
              <mat-option [value]="sex">
                {{ "sex." + sex | transloco }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <mat-form-field class="flex" hideRequiredMarker subscriptSizing="dynamic">
        <mat-label>{{ "form.label.street" | transloco }}</mat-label>
        <input formControlName="street" matInput>
      </mat-form-field>

      <div class="row">
        <mat-form-field class="flex min-width" hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ "form.label.zipCode" | transloco }}</mat-label>
          <input formControlName="zipCode" matInput>
        </mat-form-field>

        <mat-form-field class="flex min-width" hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ "form.label.city" | transloco }}</mat-label>
          <input formControlName="city" matInput>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field class="flex" floatLabel="always" hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ "form.label.country" | transloco }}</mat-label>
          <mat-select [placeholder]="'form.placeholder.select' | transloco" formControlName="countryCode">
            @for (group of countryGroups; track group.labelKey) {
              <mat-optgroup [label]="group.labelKey | transloco">
                @for (country of group.countries; track country.code) {
                  <mat-option [value]="country.code">
                    {{ country.name }}
                  </mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
          <mat-error>{{ 'form.validation.country' | transloco }}</mat-error>
        </mat-form-field>

        <mat-form-field class="flex" floatLabel="always" hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ "form.label.language" | transloco }}</mat-label>
          <mat-select [placeholder]="'form.placeholder.select' | transloco" formControlName="language">
            @for (language of languages; track $index) {
              <mat-option [value]="language">
                {{ "language." + language | transloco }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <app-phone-input formControlName="phone" label="form.label.phone"/>

      <app-phone-input formControlName="mobile" label="form.label.mobile"/>

      @if (phoneRequired) {
        <mat-error class="error">{{ 'form.validation.phoneRequired' | transloco }}</mat-error>
      }

      <div class="actions">
        <app-text-button (click)="save()" [text]="'button.save' | transloco" colorVariant="primary" leadingIcon="check_circle" type="rounded"/>
      </div>
    </form>
  </div>
}
